import { FC } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import Logo from "../../../assets/images/logo.svg";
import { Button } from "../../../components/Button";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useAppDispatch } from "../../../hooks/store.hooks";
// import { LoginUser } from "../../../store/reducers/auth/loginUser.interface";
import { loginWithOtp } from "../../../store/reducers/auth/authSlice";
import { Oval } from "react-loader-spinner";
import { useSelector } from "react-redux";

export interface OtpVerificationProps {
  [x: string]: any;
}

export const OtpVerification: FC<OtpVerificationProps> = ({
  className,
  ...restProps
}: OtpVerificationProps) => {
//   const OtpVerificationClasses = `otp-verification overflow-hidden ${className}`;
  const { isLoading, errorMsg, userData } = useSelector(
    (state: any) => state.rootReducer.auth
  );
  const dispatch = useAppDispatch();
//   console.log("OtpVerificationProps:", restProps);
  const validationSchema = Yup.object().shape({
    otp: Yup.string().required("OTP is required"),
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<any>({
    resolver: yupResolver(validationSchema),
  });
  const onSubmit: SubmitHandler<any> = async (data: any) => {
    const formData = {
      otp: data.otp,
      email: restProps?.email, // Assuming email is passed as a prop
      password: restProps?.password, // Assuming password is passed as a prop
    };
    // console.log("OTP Data:", formData);
    await dispatch(loginWithOtp(formData));
  };

  return (
    <form
      className="flex flex-col w-full max-w-lg md:p-16 p-8 rounded-lg bg-primaryDarkBg shadow-md justify-center max-lg:w-[65%] max-xl:w-[70%] max-sm:justify-start max-sm:w-[90%] max-md:w-[80%] max-md:justify-start z-50"
      //   onSubmit={handleSubmit(onSubmit)}
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className="flex items-center justify-center">
        <img className="object-cover rounded-lg w-40" src={Logo} alt="Damsel" />
      </div>
      <p className="py-6 text-2xl text-center max-sm:text-lg text-white font-bold">
        Hi, Welcome Back
      </p>
      {userData?.message && (
        <div className="bg-opacity-50 flex items-center justify-center z-40">
          <div className="text-orange-400 rounded-lg shadow-md">
            <p className="text-lg font-semibold">{userData?.message}</p>
          </div>
        </div>
      )}
      <div className="relative mb-6 max-sm:mb-3">
        <span className="text-white">
          OTP sent to your email, Please verify!
        </span>
        <input
          className={`block max-sm:text-sm w-full px-4 py-2 max-sm:h-11 h-12 m-1 shadow-md text-base font-normal text-semi transition ease-in-out bg-transparent border border-solid rounded-lg form-control bg-clip-padding focus:text-semi focus:bg-primary3 focus:outline-none ${
            errors.otp
              ? "is-invalid border-l-cancel border-cancel focus:border-cancel"
              : "border-white"
          }`}
          type={"text"}
          {...register("otp")}
          placeholder="OTP"
        />
        {/* <div className="mt-1 ml-4 font-medium text-cancel">
              {errors.otp?.message}
            </div> */}
      </div>
      <Button isLoading={isLoading.userData} size="lg" type="submit">
        <div className="flex gap-1">
          {isLoading.userData && (
            <Oval
              height={18}
              width={18}
              color="#ffff"
              wrapperStyle={{}}
              wrapperClass="max-sm:mt-[3.5px] mt-[5.2px] max-lg:mt-[5.2px]"
              visible={true}
              ariaLabel="oval-loading"
              secondaryColor="gray-primary"
              strokeWidth={6}
              strokeWidthSecondary={6}
            />
          )}
          <div className="font-normal text-base">Verify OTP</div>
        </div>
      </Button>

      <div id="errormsg" className="py-2 m-2 text-sm">
        <div>
          <p
            className="text-cancel"
            dangerouslySetInnerHTML={{ __html: errorMsg }}
          ></p>
        </div>
      </div>
    </form>
  );
};

export default OtpVerification;
